<nav-item label="Program"  [hideChevronRight]="true" [ngClass]="{'active': isActive(), 'disable-nav': isDisabled()}">
    <svg-icon key="program" fontSize="1.5rem"></svg-icon>
</nav-item>
